class SavingsCalculator
    constructor: (el) ->
        @.$el = el
        @.$cigaretteCostsEl = @.$el.querySelector '.savings-calculator__savings__cigarette-cost'
        @.$cigarettesEl = @.$el.querySelector '.savings-calculator__savings__cigarettes'
        @.$cigarettesInputEl = @.$el.querySelector '.savings-calculator__cigarettes-per-day input.savings-calculator__input__field'
        @.$cigarettesRangeEl = @.$el.querySelector '.savings-calculator__cigarettes-per-day .range'
        @.$equivalentEl = @.$el.querySelector '.savings-calculator__result__equivalent'
        @.$equivalentsEl = @.$el.querySelector '.savings-calculator__equivalents'
        @.$loader = undefined
        @.$moneyEl = @.$el.querySelector '.savings-calculator__savings__money'
        @.$yearsInputEl = @.$el.querySelector '.savings-calculator__years-of-smoking input.savings-calculator__input__field'
        @.$yearsRangeEl = @.$el.querySelector '.savings-calculator__years-of-smoking .range'

        @.api = @.$el.dataset?.api ? false
        @.apiMethod = @.$el.dataset?.apiMethod ? 'GET'
        @.calculationDelay = 150
        @.calculationInterval = undefined
        @.costsPerCigarette = if @.$cigaretteCostsEl then parseFloat(@.$cigaretteCostsEl.textContent.replace(',','.')) else 35
        @.costsToUnit = if @.$el.dataset?.ctu then parseFloat(@.$el.dataset.ctu) else .01
        @.equivalents = []
        @.maxCigarettes = if @.$el.dataset?.mc then parseInt(@.$el.dataset.mc,10) else 80
        @.maxYears = if @.$el.dataset?.my then parseInt(@.$el.dataset.my,10) else 80
        @.startCigarettes = if @.$el.dataset?.sc then parseInt(@.$el.dataset.sc,10) else 20
        @.startYears = if @.$el.dataset?.sy then parseInt(@.$el.dataset.sy,10) else 5
        @.thousandsSeparator = @.$el.dataset?.tSep ? false

        @.cigarettes = @.startCigarettes
        @.years = @.startYears

        @.$el.classList.add 'savings-calculator--bound'
        @.GetEquivalents()
        if @.equivalents.length > 0
            @.InitEvents()
            @.CalculateResult()
        else
            if @.api
                @.CreateLoader()
                @.GetData()
            else
                @.Destroy()
            delete @
        return
    
    CalculateResult: ->
        self = @
        smokedCigarettes = @.cigarettes * 365 * @.years
        @.$cigarettesEl.textContent = if @.thousandsSeparator then smokedCigarettes.toString().replace(/\B(?=(\d{3})+(?!\d))/g, @.thousandsSeparator) else smokedCigarettes
        savings = parseInt (smokedCigarettes * @.costsPerCigarette) * @.costsToUnit
        @.$moneyEl.textContent = if @.thousandsSeparator then savings.toString().replace(/\B(?=(\d{3})+(?!\d))/g, @.thousandsSeparator) else savings
        @.$equivalentEl.textContent = ""
        @.equivalents.forEach (equivalent) ->
            if savings >= equivalent.cost
                self.$equivalentEl.textContent = equivalent.text
        return
    
    CreateLoader: ->
        if !@.$loader
            @.$loader = document.createElement 'div'
            @.$loader.classList.add 'savings-calculator__loader'
            elCls = @.$el.classList
            loaderColor = switch
                when elCls.contains('savings-calculator--green') then 'green-dark'
                when elCls.contains('savings-calculator--purple') then 'purple-dark'
                when elCls.contains('savings-calculator--red') then 'red-dark'
                when elCls.contains('savings-calculator--turqois') then 'turqois-dark'
                else 'black'

            @.$loader.appendChild window.CreateLoader {
                color: loaderColor
                shown: true
            }
            @.$el.appendChild @.$loader
            window.dispatchEvent new CustomEvent 'bind-components'
        return
    
    Destroy: ->
        @.$el.remove()
        delete @
        return
    
    GetData: ->
        if @.apiMethod == 'GET' || @.apiMethod == 'POST'
            self = @
            try
                request = window.appUtils.XMLHttpRequest @.apiMethod, @.api
                    , ->
                        if request.responseText && request.responseText != ""
                            try
                                answer = JSON.parse request.responseText
                                self.costsPerCigarette = answer.cigaretteCosts
                                self.equivalents = answer.equivalents
                                self.$cigaretteCostsEl.textContent = self.costsPerCigarette
                                if self.equivalents.length > 0
                                    self.InitEvents()
                                    self.CalculateResult()
                                    self.RemoveLoader()
                                else
                                    self.Destroy()
                            catch error
                                console.log "Fehler beim Versuch die Datenquelle für den Ersparnisrechner zu verarbeiten"
                                self.Destroy()
                                return
                        else
                            console.log "Die Anfrage der Datenquelle für den Ersparnisrechner lieferte ein leeres Ergebnis"
                            self.Destroy()
                    , ->
                        self.Destroy()
                        console.log "Bei der Anfrage an die Datenquelle für den Ersparnisrechner ist leider ein Fehler aufgetreten"
                        return
            catch error
                console.log "Fehler beim Versuch die Datenquelle für den Ersparnisrechner zu ermitteln"
                self.Destroy()
        else
            try
                if window[@.api]
                    @.results = window[@.api]
                else
                    console.log "Fehler beim Versuch die Datenquelle für den Ersparnusrechner zu ermitteln"
                @.Destroy()
            catch error
                console.log "Fehler beim Versuch die Datenquelle für den Ersparnisrechner zu verarbeiten"
                @.Destroy()
        return


    GetEquivalents: ->
        self = @
        @.$equivalentsEl.querySelectorAll '.savings-calculator__equivalent'
            .forEach (equivalentEl) ->
                if equivalentEl.dataset?.cost && equivalentEl.textContent != ''
                    self.equivalents.push {
                        cost: parseFloat equivalentEl.dataset.cost
                        text: equivalentEl.textContent
                    }
                return
        @.$equivalentsEl.remove()
        @.$equivalentsEl = null
        return
    
    RemoveLoader: ->
        if @.$loader
            @.$loader.remove()
        return
    
    InitEvents: ->
        self = @
        @.$cigarettesInputEl.addEventListener 'change', (e) ->
            value = if @.value == '' then 0 else parseInt @.value, 10
            if value < 0
                value = 0
                @.value = 0
            if value > self.maxCigarettes
                value = self.maxCigarettes
                @.value = self.maxCigarettes
            self.cigarettes = value
            self.CalculateResult()
            self.$cigarettesRangeEl.dispatchEvent new CustomEvent 'range-set-value', {
                bubbles: false
                detail: {
                    triggerEvents: false
                    value: value
                }
            }
            if @.value == ''
                @.value = value
            return
        @.$cigarettesRangeEl.querySelector 'input[type="range"]'
            .addEventListener 'input', (e) ->
                value = parseInt @.value
                self.$cigarettesInputEl.value = value
                self.cigarettes = value
                self.CalculateResult()
                return

        @.$yearsInputEl.addEventListener 'input', (e) ->
            value = if @.value == '' then 0 else parseInt @.value, 10
            if value < 0
                value = 0
                @.value = 0
            if value > self.maxYears
                value = self.maxYears
                @.value = self.maxYears
            self.years = value
            self.CalculateResult()
            self.$yearsRangeEl.dispatchEvent new CustomEvent 'range-set-value', {
                bubbles: false
                detail: {
                    triggerEvents: false
                    value: value
                }
            }
            if @.value == ''
                @.value = value
            return
        @.$yearsRangeEl.querySelector 'input[type="range"]'
            .addEventListener 'input', (e) ->
                value = parseInt @.value
                self.$yearsInputEl.value = value
                self.years = value
                self.CalculateResult()
                return
        return

BindSavingsCalculators = ->
    document.querySelectorAll '.savings-calculator:not(.savings-calculator--bound)'
        .forEach (el) ->
            new SavingsCalculator el
            return
    return

window.addEventListener 'bind-components', BindSavingsCalculators